<template>
  <hs-modal
    :model-value="true"
    :title="title || ''"
    :size="resolvedSize"
    :z-index="isNested ? 5400 : 5200"
    :panel-class="['legacy-modal-view', customClass, { 'legacy-modal-view--fullscreen': forceFullWidth }]"
    :body-class="customClassContent"
    :panel-style="computedPanelStyle"
    :body-style="computedBodyStyle"
    @update:modelValue="handleModelValue"
  >
    <slot />
  </hs-modal>
</template>

<script>
import { HsModal } from "@/components/ui";

export default {
  name: "ModalView",
  components: { HsModal },
  props: {
    title: {
      type: String,
      default: "",
    },
    customClassContent: {
      type: String,
      default: "",
    },
    customMaxWidth: {
      type: String,
      default: null,
    },
    customContentHeight: {
      type: String,
      default: null,
    },
    forceFullWidth: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    isNested: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close-modal"],
  computed: {
    resolvedSize() {
      if (this.forceFullWidth) return "xl";
      if (!this.customMaxWidth) return "lg";
      const width = parseInt(this.customMaxWidth, 10);
      if (!Number.isFinite(width)) return "lg";
      if (width <= 520) return "sm";
      if (width >= 1000) return "xl";
      return "lg";
    },
    computedPanelStyle() {
      const style = {};
      if (this.customMaxWidth) {
        style.width = `min(100%, ${this.customMaxWidth})`;
      }
      if (this.forceFullWidth) {
        style.width = "100vw";
        style.maxWidth = "100vw";
        style.height = "100vh";
        style.maxHeight = "100vh";
        style.borderRadius = "0";
      }
      return style;
    },
    computedBodyStyle() {
      if (!this.customContentHeight) return null;
      return { height: this.customContentHeight };
    },
  },
  methods: {
    handleModelValue(open) {
      if (!open) {
        this.$emit("close-modal");
      }
    },
  },
};
</script>

<style scoped>
:deep(.legacy-modal-view.modal-wide) {
  width: min(96vw, 1100px);
}

:deep(.legacy-modal-view--fullscreen .hs-modal__body) {
  max-height: calc(100vh - 5.5rem);
}
</style>
